import { useSession } from '@openx/utils/permission/useSession.ts';

export const useCurrentInstanceState = () => {
  const { session } = useSession();

  return {
    currentInstanceUid: session?.instance?.uid,
    isBefInstance: session?.instance?.experience === 'bef',
  };
};
